import { render, staticRenderFns } from "./ring.vue?vue&type=template&id=50c860d1&scoped=true&"
import script from "./ring.vue?vue&type=script&lang=js&"
export * from "./ring.vue?vue&type=script&lang=js&"
import style0 from "./ring.vue?vue&type=style&index=0&id=50c860d1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50c860d1",
  null
  
)

export default component.exports